import {
  Box,
  SectionHelper,
  SectionHelperProps,
  Text,
} from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import s from './PriceTaxExclusiveNotice.module.scss';

export const dataHooks = {
  container: 'price-tax-exclusive-notice-container',
};

interface Props {
  shouldShowPriceNotice: boolean;
  className?: string;
  sectionHelperProps?: SectionHelperProps;
}

const PriceTaxExclusiveNotice = ({
  shouldShowPriceNotice,
  className,
  sectionHelperProps = {},
}: Props) => {
  const { t } = useTranslation();

  if (!shouldShowPriceNotice) {
    return null;
  }

  return (
    <Box
      className={className ?? s.priceNoticeDesktopPositioning}
      dataHook={dataHooks.container}
    >
      <SectionHelper
        skin="preview"
        fullWidth
        size="small"
        {...sectionHelperProps}
      >
        <Text size="small" weight="normal">
          {t('marketplace.templates-page.price-tax-exclusive-notice')}
        </Text>
      </SectionHelper>
    </Box>
  );
};

export default PriceTaxExclusiveNotice;
